// import superagent from 'superagent';

import Cookie from '@/lib/cookie.js';
import $http  from '@/lib/network.js';
import store from '@/store'
import MD5 from '@/lib/md5.js'
import Vue from "vue";
import Toast from "@/lib/toast"

window.iCookie = Cookie;
window.MD5 = MD5;

const Util = {
    ...Toast,
  /**
   * 七牛上的图片，显示小图（添加后缀-mdl即可）
   * 特别注意：透明背景的图片，压缩之后可能会有白色背景
   */
   smallImage(imgurl) {
    if (!imgurl) return imgurl;
    if (imgurl.indexOf('static.duobao100.com') >= 0 && imgurl.indexOf('-mdl') < 0 && imgurl.indexOf('-lrg') < 0) {
      return imgurl + '-mdl';
    }
    return imgurl;
  },

  /**
   * 格式化时间
   * @param  {[Date]} date       [时间]
   * @param  {[String]} formatType [时间格式]
   * @return {[String]}            [时间字符串]
   */
  formatTime(date, formatType){
    if (!(date instanceof Date)) {
      date += '';
      date = date.replace(/-/g, '/');
      date = new Date(date);
    }
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    let time;
    if (formatType) {
      time = formatType.replace(/yy/i, year).replace('MM', month < 10 ? '0' + month : month).replace(/dd/i, day < 10 ? '0' + day : day).replace(/hh/i, hour).replace('mm', minute < 10 ? '0' + minute : minute).replace('ss', second < 10 ? '0' + second : second);
    } else {
      time = [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':');
    }

    return time;
  },

  /**
   * 用于判断空，Undefined String Array Object
   * 使用方法 util.String.isBlank(str)
   * 返回boolean
   */
   isBlank(str) {
      if (this.isUndefined(str)) { //空
        return true
      } else if (this.isString(str) || this.isArray(str)) { //字符串或数组
        return str.length == 0 ? true : false
      } else if (this.isObject(str)) {
        return JSON.stringify(str) == '{}' ? true : false
      } else if (this.isNumber(str)) {
        return false
      } else {
        return false
      }
  },

  isFunction(value) {
    return Object.prototype.toString.call(value) == '[object Function]';
  },

  isString(value) {
    return Object.prototype.toString.call(value) == '[object String]';
  },

  isBoolean(value) {
    return Object.prototype.toString.call(value) == '[object Boolean]';
  },

  isUndefined(value) {
    return Object.prototype.toString.call(value) == '[object Undefined]';
  },

  isNumber(value) {
    return Object.prototype.toString.call(value) == '[object Number]';
  },
  isSymbol(value) {
  return Object.prototype.toString.call(value) == '[object Symbol]';
  },
  isNull(value) {
    return Object.prototype.toString.call(value) == '[object Null]';
  },

  isArray(value) {
    return Object.prototype.toString.call(value) == '[object Array]';
  },

  isObject(value) {
    return (
      Object.prototype.toString.call(value) == '[object Object]' ||
      // if it isn't a primitive value, then it is a common object
      (!this.isNumber(value) &&
        !this.isString(value) &&
        !this.isBoolean(value) &&
        !this.isArray(value) &&
        !this.isNull(value) &&
        !this.isFunction(value) &&
        !this.isUndefined(value) &&
        !this.isSymbol(value)
      )
    )
  },

  isWeiXin(){
    var ua = navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') != -1) {
        return true;
    } else {
        return false;
    }
  },

  isIos(){
    var u = navigator.userAgent;
    if (u.indexOf('iPhone') > -1){
      return true;
    }else{
      return false;
    }
  },

  isAndroid(){
    var u = navigator.userAgent;
    if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
         return true;
    }else{
      return false;
    }
  },

  goTo(url,pramas){
    let pramasUrl = '';
    let _url = url;
    for(let i in pramas){
      pramasUrl += ( `${i}=${pramas[i]}&` )
    }
    pramasUrl = pramasUrl.substr(0,pramasUrl.length-1);
    if(pramasUrl){
      let lastStr = pramasUrl.substr(pramasUrl.length-1,1);
      if(url.indexOf('?')>-1){
        if(lastStr=='?'||lastStr=='&'){
          _url += pramasUrl;
        }else{
          _url += `&${pramasUrl}`;
        }
      }
    }
    if(window.location&&_url){
      window.location.href = _url;
    }
  },

  getCurrentUrl(){
    let url = window.location.href;
    // if(this.isIos()){
    //   let _url = store.state.user.currentUrl;
    //   if(_url){
    //     url = _url;
    //   }
    // }
    return url;
  },

  getShareUrl(targetUrl){ //未启用
    if(!targetUrl){
      targetUrl = window.location.href;
    }
    let redirect = window.location.protocol+'//'+window.location.host+'/h5static/share.html?r='+encodeURIComponent(targetUrl);
    return redirect;
  },
  restoreCurrentUrl(){
    return
    if(this.isIos()){
      let _url = this.getCurrentUrl();
      if(_url){
        window.history.replaceState({}, '', _url);
      }
    }
  },

  //复制对象
  oCopy(obj) {
    return JSON.parse(JSON.stringify(obj))
  },
  //复制对象
  oCopyDeep(obj,noKey) {
    let cObj;
    if (this.isObject(obj) || this.isArray(obj)) {
      cObj = this.isObject(obj) ? {} : [];
      for (let i in obj) {
        if(noKey != i){
          cObj[i] = this.oCopyDeep(obj[i]);
        }
      }
    } else {
      cObj = obj;
    }
    return cObj;
    // return JSON.parse(JSON.stringify(obj))
  },
  /**
   * 修改当前页面URL参数
   * @param  {[String]} paramName   [替换的参数名]
   * @param  {[String]} replaceWith [替换后的值]
   * @return {[String]}             [替换后的链接]
   */
  replaceParamVal(paramName,replaceWith) {
    var oUrl = window.location.href;
    var re=eval('/('+ paramName+'=)([^&]*)/gi');
    if (re.test(oUrl)){
        var nUrl = oUrl.replace(re,paramName+'='+replaceWith);
    }else{
    if(oUrl.indexOf('?')>0){
        var nUrl = oUrl+"&"+paramName+"="+replaceWith;
    }else{
        var nUrl = oUrl+"?"+paramName+"="+replaceWith;
    }
    }
    return nUrl;
  },

  /**
   * 修改URL参数
   * @param  {[String]} url     [url]
   * @param  {[String]} arg     [参数名]
   * @param  {[String]} arg_val [参数对应的值]
   * @return {[String]}         [修改后的URL]
   */
  changeURLArg(url,arg,arg_val){
      var pattern=arg+'=([^&]*)';
      var replaceText=arg+'='+arg_val;
      if(url.match(pattern)){
          var tmp='/('+ arg+'=)([^&]*)/gi';
          tmp=url.replace(eval(tmp),replaceText);
          return tmp;
      }else{
          if(url.match('[\?]')){
              return url+'&'+replaceText;
          }else{
              return url+'?'+replaceText;
          }
      }
  },

  /**
   * 上传图片至七牛
   * @param  {[File]} file [文件]
   * @return {[String]}      [图片七牛路径]
   */
  uploadImage(file){
    return new Promise((resolve,reject)=>{
      $ajax.post('/api/v1/upload/get_qiniu_token').then(res=>{
        let token = res.data.data.token;
        let formData = new FormData();
        formData.append('token',token);
        formData.append('file',file);
        // formData.append('key',token);
        $ajax.post('https://up-z2.qiniup.com',formData).then(qiniuRes=>{
          let imageUrl = Config.qiniuImageHead+'/'+qiniuRes.data.key;
          resolve(imageUrl);
        }).catch(err=>{
          reject(err)
        })
      }).catch(err=>{
        reject(err)
      })
    })
  },

  useJsdK(path){
    var _location = window.location;
    if(_location.pathname){
      var pathnameArr =  _location.pathname.split('/');
      if(pathnameArr[1] == 'bd' || pathnameArr[2] == 'bd'){
        return
      }
    }
    store.dispatch('setWxIsReady',false);
    if(path){
      if(path.indexOf('http'==-1)){
        // path = path == ''?''
        path = _location.protocol + '//' +_location.host+'/xbsh5'+path;
      }
    }else{
      path = _location?_location.href:'';
    }
    // console.log(path);
    let currentUrl = path.split('#')[0];
    // currentUrl = encodeURIComponent(currentUrl);
    // console.log('currentUrl----'+currentUrl);
    // let currentUrl = window.location?encodeURIComponent(window.location.href.split('#')[0]):'';
    $http.defaults.headers.post['source'] = 'xiaobaoshu' ;
    $http.post('/api/v1/wxchat/jssdk',{url:currentUrl}).then(res => {
      // console.log('注册jsjsdk',res);
      let params={};
      params.config = res.data.data;
      params.config.debug = false;
      delete params.config.url;
      store.dispatch('wxRegister',params);
    })
  },

  Cookie:Cookie,
  MD5:MD5,
  getUrlQuery(name,value){
    let url = window.location.href;
    let patt = new RegExp("[\?\&]"+name+"=([^&]+)");
    let res = url.match(patt);
    if(res){
      let val = res[1]?res[1]:value;
      return val
    }else{
      return value;
    }
  },   

  // 获取微信公众号转化跟踪token
  getWXtoken(typ){
    $http.get('/api/v1/miniWechat/access_token?account='+typ).then(response => {
                
          return response.data.data;
      })
      .catch(() => {

      });
  },

  // 投放页面保存客户临时信息
  saveOpRecords(formDate,channelCode,startTime,endTime){
    
      let obj = new Object();
      obj.url = window.location.href;
      if(channelCode){
        obj.channel_code = channelCode;
      }

      if(formDate.mobile && formDate.mobile.length == 11 && formDate.mobile[0] == 1){
        obj.phone = formDate.mobile;
      }

      if(formDate.real_name){
        obj.name = formDate.real_name;
      }

      if(startTime){
        obj.subscribe_start_time = startTime;
      }

      if(endTime){
        obj.subscribe_end_time = endTime;
      }
      if(oldDate == obj){
        
      }
      if(obj.phone || obj.name || obj.subscribe_start_time || obj.subscribe_end_time){
        $http.post('/api/v1/b_customer_behavior_records',obj).then(response => {
            
        })
        .catch(() => {
            
        });
      }
      
  },
  /**
     * 倒计时
     * total 总时间
     * step  单步减少的时间 step<0 为正计时，step>0 为倒计时
     * targetNum 目标时间
     * stepTime  单步所需时间
     * stepCallBack 单步回调
     * completeCallBack 倒计时完成回调
     * 
     * @return { function }clearTiemer 调用返回函数取消倒计时
     */
    timeDown: function(options){
      var total = options.total;
      var step = options.step;
      var targetNum = options.targetNum;
      var stepTime = options.stepTime;
      var stepCallBack = options.stepCallBack;
      var completeCallBack = options.completeCallBack;


      if(!stepTime) {
          stepTime = 1000;
      }
      var timer = null;
      var timeDownAction = function(){
      if( (step>0 && total<=targetNum) || (step<0 && total>=targetNum) ){
          completeCallBack && completeCallBack(total)
          return
      }
      stepCallBack && stepCallBack(total);
      timer = setTimeout(function(){
          total-= step;
          timeDownAction()
      },stepTime)
      }
      timeDownAction();

      return function(){
          clearTimeout(timer)
      }
  },
  leftPadZero(val){
    if(val>9){
      return val
    }else{
      return '0'+val
    }
  },
  formatTimeStr(time,format){
    format = format ? format : 'MM:SS';
    let ms = time%1000;
    let hh = Math.floor(time/(60*60*1000));
    let mm = Math.floor((time-hh*60*60*1000)/(60*1000));
    let ss = Math.floor((time-hh*60*60*1000-mm*60*1000)/1000);
    return format.replace('HH',this.leftPadZero(hh)).replace('MM',this.leftPadZero(mm)).replace('SS',this.leftPadZero(ss)).replace('sss',ms).replace('ss',this.leftPadZero(Math.ceil(ms/10))).replace('s',Math.ceil(ms/100))
  },

  deleteOpRecords(){
    $http.post('/api/v1/customer_success').then(response => {

        })
        .catch(() => {

        });
  },

  // 微信转化追踪回传数据
  postWXtrack(obj){
    $http.post('/api/v1/user_action',obj).then(response => {
                
          console.log('回传成功');
      })
      .catch(() => {

      });
  },

  V(obj, rules, config = {}){
    let _config = {
      msgHide: false
    }
    let self = this;
    config = Object.assign(_config, config);
    if (!this.isObject(obj)) {
      console.error('被检查的参数必须为Object类型');
      return;
    }
    for (let i in obj) {
      if (!rules[i]) {
        continue;
      }
      for (let j in rules[i]) {
        let rule = rules[i][j].rule;
        let msg = rules[i][j].msg;
        let ret = checkRule(obj[i], rule);
        if (!ret) {
          !config.msgHide && msg && Vue.prototype.$toast({txt:msg});
          return false;
        }
      }

    }
    return true;

    function checkRule(value, rule) {
      if (rule == 'require') {
        if (self.isBlank(value)) {
          return false;
        }
      } else if (rule == 'phone') {
        if (value === '') { //空值不做检查-如需判空请增加require规则
          return true
        }
        if (!/1[3-9][0-9]{9}$/.test(value)) {
          return false;
        }
      } else if (rule == 'Number') {
        if (/\D/.test(value)) {
          return false;
        }
      } else if (rule == 'email') {
        if (value === '') { ////空值不做检查-如需判空请增加require规则
          return true
        }
        if (!/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)) {
          return false;
        }
      } else if (/max\(\d+\)$/.test(rule)) {
        let len = rule.match(/\d+/)[0];
        if (!(self.isNumber(value) || self.isString(value) || self.isArray(value))) {
          return false
        } else if (self.isNumber(value) || self.isString(value)) {
          let _value = value + '';
          if (_value.length > len) {
            return false;
          }
        } else if (self.isArray(value)) {
          if (value.length > len) {
            return false;
          }
        }
      } else if (/min\(\d+\)$/.test(rule)) {
        let len = rule.match(/\d+/)[0];
        if (!(self.isNumber(value) || self.isString(value) || self.isArray(value))) {
          return false
        } else if (self.isNumber(value) || self.isString(value)) {
          let _value = value + '';
          if (_value.length < len) {
            return false;
          }
        } else if (self.isArray(value)) {
          if (value.length < len) {
            return false;
          }
        }
      } else if (self.isFunction(rule)) {
        return rule(value);
      } else {
        return true;
      }

      return true;
    }
  },
  jsonParse(jsonStr,def={}){
    let res = def;
    try{
      res = JSON.parse(jsonStr)
    }catch(err){
      return def;
    }
    return res;
  },
        /**
   * 函数节流 返回函数连续调用时，fn 执行频率限定为每多少时间执行一次
   * @param fn         {function}  需要调用的函数
   * @param delay      {number}    延迟时间，单位毫秒
   * @param immediate  {bool}      是否立即执行
   * @return           {function}  实际调用函数
   */
  throttle(fn, delay, immediate = false, debounce = false) {
    let curr = +new Date()
    let last_call = 0
    let last_exec = 0
    let timer = null
    let diff
    let context
    let args
    const exec = function() {
      last_exec = curr
      fn.apply(context, args)
    }

    return function() {
      curr = +new Date()
      context = this
      args = arguments
      diff = curr - (debounce ? last_call : last_exec) - delay

      clearTimeout(timer)

      if (debounce) {
        if (!immediate) {
          timer = setTimeout(exec, delay)
        } else if (diff >= 0) {
          exec()
        }
      } else {
        if (diff >= 0) {
          exec()
        } else if (!immediate) {
          timer = setTimeout(exec, -diff)
        }
      }

      last_call = curr
    }
  },

  /**
   * 函数去抖 返回函数连续调用时，空闲时间必须大于或等于 delay，fn 才会执行
   * @param fn         {function}  需要调用的函数
   * @param delay      {number}    空闲时间，单位毫秒
   * @param immediate  {bool}      是否立即执行
   * @return           {function}  实际调用函数
   */
  debounce(fn, delay, immediate = false) {
    return this.throttle(fn, delay, immediate, true)
  },

  /****
   * 图片懒加载
   * 
   */
  lazyLoadImg(scrollCall){
  
    function lazyLoad(){
      var imgs = document.querySelectorAll('img');
      //用来判断bound.top<=clientHeight的函数，返回一个bool值
      function isIn(el) {
          var bound = el.getBoundingClientRect();
          var clientHeight = window.innerHeight;
          return bound.top <= clientHeight+100;
      } 
      //检查图片是否在可视区内，如果不在，则加载
      function check() {
          Array.from(imgs).forEach(function(el){
              if(isIn(el)){
                  loadImg(el);
              }
          })
      }
      function loadImg(el) {
          if(!el.src){
              var source = el.dataset.src;
              el.src = source;
          }
      }
      check();
    }

    function removeScroll (){
      window.removeEventListener('scroll', scrollCall)
    }
   
    window.addEventListener("scroll",()=>{
      scrollCall && scrollCall();
      lazyLoad();
    });
    lazyLoad();

    return{
      removeScroll:removeScroll
    }
  },
 /**
   *  手机 格式校验
   */
  isMobile(mobile){
    let myreg = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
    if (!myreg.test(mobile)) {
      Vue.prototype.$toast({ txt: "请填写正确手机号码" });
      return false;
    }
    return true;
  }

}

export default Util;



// WEBPACK FOOTER //
// ./src/lib/utils.js